import { COPY } from "./copy";

const X_STOCKS_DISCLAIMER = {
    text: COPY.X_STOCKS_HOURS_DISCLAIMER,
    link: COPY.MARKET_HOURS_DISCLAIMER_LINK
};

export const MARKET_HOURS_DISCLAIMERS: Record<string, { text: string; link: string }> = {
    AbVzeRUss8QJYzv2WDizDJ2RtsD1jkVyRjNdAzX94JhG: {
        text: COPY.FLP_2_HOURS_DISCLAIMER,
        link: COPY.MARKET_HOURS_DISCLAIMER_LINK
    },
    XsueG8BtpquVJX9LVLLEGuViXUungE6WmK5YZ3p3bd1: X_STOCKS_DISCLAIMER,
    EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v: X_STOCKS_DISCLAIMER,
    Xsc9qvGR1efVDFGLrVsmkzv3qi45LTBjeUKSPmx9qEh: X_STOCKS_DISCLAIMER,
    XsDoVfqeBukxuZHWhdvWHBhgEHjGNst4MLodqsJHzoB: X_STOCKS_DISCLAIMER
};
